<template>
    <div>

        <!-- Header -->
        <header id="header">
            <h1 id="site-title">ビジネスキャラ診断<small>サイトエンジン株式会社</small></h1>
            <!-- <div>
                <router-link to="/" class="nav-item nav-link">マイページ</router-link>
                <a style="cursor: pointer;" @click="$parent.logout">ログアウト</a>
            </div> -->
        </header>

        <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="collapse navbar-collapse">
                <div class="navbar-nav">
                    <router-link to="/" class="nav-item nav-link">TOP</router-link>
                    <router-link to="/about" class="nav-item nav-link">ABOUT</router-link>
                    <router-link to="/mypage" class="nav-item nav-link">MY PAGE</router-link>
                    <router-link to="/register" class="nav-item nav-link" v-if="!isLoggedIn">Register</router-link>
                    <router-link to="/login" class="nav-item nav-link" v-if="!isLoggedIn">LOGIN</router-link>
                    <a class="nav-item nav-link" style="cursor: pointer;" @click="$parent.logout">ログアウト</a>
                    <router-link to="/admin/login" class="nav-item nav-link">ADMIN</router-link>
                </div>
            </div>
        </nav>
        Welcome {{ name }} -->

    </div>
</template>

<style>
    #header {
        align-items: center;
        justify-content: space-between;
    }
</style>

<script>
    export default {
        data() {
            return {
                isLoggedIn: false,
                name: null,
            }
        },
        created() {
            // ログイン済の場合
            if (window.Laravel.isEmployeeLoggedin) {
                this.isLoggedIn = true
                // if (window.Laravel.employee) {
                //     this.name = window.Laravel.employee.name
                // }
            }
        },
        methods: {
        },
    }
</script>
